import type { IDateTime } from '../../../types/post'
import { EditableDateTimeField } from './editable-date-time-field'

interface DateTimeFieldProps {
  dateTime: IDateTime | null
  disabled?: boolean
  onUpdate: (dateTime: IDateTime | null) => void
  className?: string
}

/**
 * DateTimeField component with enhanced edit mode functionality
 * - Click to edit with save/cancel options
 * - Type time directly in 24-hour format
 * - No immediate updates until save is clicked
 */
export function DateTimeField({ dateTime, onUpdate, disabled, className }: DateTimeFieldProps) {
  return (
    <EditableDateTimeField
      dateTime={dateTime}
      onUpdate={onUpdate}
      disabled={disabled}
      className={className}
      placeholder="Click to set date/time"
    />
  )
}
